import { IFailedSlipResult, IPlacedSlipResult, ISucceededPartialSlipResult, ISucceededSlipResult, SlipResultStatus } from './models';

export function isSucceededSlip(slip: IPlacedSlipResult): slip is ISucceededSlipResult | ISucceededPartialSlipResult {
    return slip.status === SlipResultStatus.Success;
}

export function isFailedSlip(slip: IPlacedSlipResult): slip is IFailedSlipResult {
    return slip.status === SlipResultStatus.Fail;
}

export function isSucceededNonPartialSlip(slip: IPlacedSlipResult): slip is ISucceededSlipResult {
    return slip.status === SlipResultStatus.Success && !!(<ISucceededSlipResult>slip).picks;
}

export function isPartialSlip(slip: IPlacedSlipResult): boolean {
    return isSucceededSlip(slip) && (<ISucceededSlipResult>slip).picks === undefined;
}
